if (!customElements.get('cro-feature-tabs')) {
  customElements.define(
    'cro-feature-tabs',
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.dots = Array.from(this.querySelectorAll('.cro-ftabs__dot'));
        this.indicator = this.querySelector('.cro-ftabs__indicator');
        this.strip = this.querySelector('[role="tablist"]');
        this.strip.addEventListener('mouseleave', () => this.moveIndicator(this.activeTab()));
        document.fonts?.ready.then(() => this.moveIndicator(this.activeTab()));
        new ResizeObserver(() => this.moveIndicator(this.activeTab())).observe(this.strip);
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.select(i)));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('mouseenter', () => this.moveIndicator(tab));
          tab.addEventListener('keydown', (e) => {
            const dirs = { ArrowLeft: -1, ArrowRight: 1 };
            let target = null;
            if (e.key in dirs) target = (i + dirs[e.key] + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') target = 0;
            if (e.key === 'End') target = this.tabs.length - 1;
            if (target !== null) {
              e.preventDefault();
              this.select(target);
              this.tabs[target].focus();
            }
          });
        });
      }

      activeTab() {
        return this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      }

      moveIndicator(tab) {
        if (!this.indicator || !tab) return;
        this.indicator.style.left = `${tab.offsetLeft}px`;
        this.indicator.style.width = `${tab.offsetWidth}px`;
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach((panel, i) => {
          panel.setAttribute('aria-hidden', i === index ? 'false' : 'true');
          panel.toggleAttribute('inert', i !== index);
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
        this.moveIndicator(this.tabs[index]);
        if (this.strip.scrollWidth > this.strip.clientWidth) {
          const tab = this.tabs[index];
          const left = tab.offsetLeft - (this.strip.clientWidth - tab.offsetWidth) / 2;
          this.strip.scrollTo({ left, behavior: 'smooth' });
        }
      }
    }
  );
}
